import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftTeamsSenderServer } from "namirasoft-teams-sender";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { TeamsSenderLayout } from "./TeamsSenderLayout";
import { TeamsSenderRoutes } from "./TeamsSenderRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ProviderEditPage from "./pages/ProviderEditPage";
import ProviderListPage from "./pages/ProviderListPage";
import ProviderViewPage from "./pages/ProviderViewPage";
import SendPage from "./pages/SendPage";
import SentListPage from "./pages/SentListPage";
import VerifyChannelPage from "./pages/VerifyChannelPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_TEAMS_SENDER}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_TEAMS_SENDER = new EnvService("REACT_APP_BASE_URL_TEAMS_SENDER", true).getString();

            let teams_sender = new NamirasoftTeamsSenderServer(REACT_APP_BASE_URL_TEAMS_SENDER, result.account.token_manager, result.notifier.onError);

            let servers = { teams_sender };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={TeamsSenderRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={TeamsSenderRoutes.ProviderList} element={<ProviderListPage {...result} servers={servers} />} />
                            <Route path={TeamsSenderRoutes.ProviderNew} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={TeamsSenderRoutes.ProviderView(":id")} element={<ProviderViewPage {...result} servers={servers} />} />
                            <Route path={TeamsSenderRoutes.ProviderEdit(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={TeamsSenderRoutes.ProviderCopy(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={TeamsSenderRoutes.Verify(":provider_id")} element={<VerifyChannelPage {...result} servers={servers} />} />

                            <Route path={TeamsSenderRoutes.Send(null)} element={<SendPage {...result} servers={servers} />} />
                            <Route path={TeamsSenderRoutes.Send(":id")} element={<SendPage {...result} servers={servers} />} />

                            <Route path={TeamsSenderRoutes.SentList} element={<SentListPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={TeamsSenderRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <TeamsSenderLayout {...props}>
                {props.children}
            </TeamsSenderLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;